export const MAP_URL =
  "https://www.google.com/maps/dir//1991+Village+Park+Way,+Encinitas,+CA+92024/@33.053135,-117.3280127,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x80dc0b95bd8b1c0f:0xd2d309cdd42fa7b!2m2!1d-117.2456115!2d33.0531621?entry=ttu";

export const BUSINESS_ADDRESS = "1991 Village Park Way, Encinitas, CA 92024";
